import { render, staticRenderFns } from "./GBChartContent.vue?vue&type=template&id=0c8f0fc2&"
import script from "./GBChartContent.vue?vue&type=script&lang=js&"
export * from "./GBChartContent.vue?vue&type=script&lang=js&"
import style0 from "./GBChartContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports